function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState } from 'react';
import { Redirect, useLocation } from 'react-router';
import { OFACScreeningStatusEnum } from 'anchor-kyb-service/types';
import { Spinner, useOverlayContext } from 'seagull';
import GenericError from "../../components/GenericError/GenericError";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { routes } from "../../constants";
import { useIoContext, useStoreActions } from "../../contexts";
import { useOnMount } from "../../hooks/useOnMount";
import { LatestOFACSanctionStatusModel } from "../../models";
import { jsx as _jsx } from "react/jsx-runtime";
const renderLoader = () => /*#__PURE__*/_jsx(Spinner, {
  "data-testid": "loading-ofac-data",
  centeredInBox: true,
  centerBoxHeight: "100%"
});
const renderError = () => /*#__PURE__*/_jsx(GenericError, {
  testid: "ofac-error"
});
function RedirectToHome(_ref) {
  let {
    detailsAdded
  } = _ref;
  const {
    showSuccessToast
  } = useOverlayContext();
  useOnMount(() => {
    if (detailsAdded) {
      showSuccessToast('The additional details have been successfully added.', 'details-added');
    }
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: routes.home
  });
}
function OpenPersonaInquiry(_ref2) {
  let {
    inquiryId,
    sessionToken
  } = _ref2;
  const {
    personaClient,
    locationReload
  } = useIoContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [complete, setComplete] = useState(false);
  const persona = useMemo(() => {
    return personaClient({
      onError: () => setError(true),
      onReady: () => setLoading(false),
      onComplete: () => setComplete(true),
      onCancel: () => locationReload()
    });
  }, []);
  useOnMount(() => {
    persona.open(inquiryId, sessionToken);
  });
  if (error) return renderError();
  if (loading) return renderLoader();
  if (complete) return /*#__PURE__*/_jsx(RedirectToHome, {
    detailsAdded: true
  });
  return null;
}
export async function fetchInquiry(_ref3) {
  let {
    data,
    getUserStatus,
    getBusinessStatus,
    createInquiry
  } = _ref3;
  const defaultStatus = new LatestOFACSanctionStatusModel({
    status: OFACScreeningStatusEnum.Cleared
  });
  const userStatusPromise = data.user.isSanctioned ? getUserStatus(data.user.id) : Promise.resolve(defaultStatus);
  const businessStatusPromise = data.business.isSanctioned ? getBusinessStatus(data.business.id) : Promise.resolve(defaultStatus);
  const [userStatus, businessStatus] = await Promise.all([userStatusPromise, businessStatusPromise]);
  const inquiryPayload = {
    userId: userStatus.requiresInquiry() ? data.user.id : undefined,
    businessId: businessStatus.requiresInquiry() ? data.business.id : undefined
  };
  if (inquiryPayload.userId || inquiryPayload.businessId) {
    const inquiry = await createInquiry(inquiryPayload);
    return {
      inquiry
    };
  } else {
    return {
      inquiry: null
    };
  }
}
export default function AdditionalPaymentProcessorInfoPage() {
  const {
    state
  } = useLocation();
  const {
    api
  } = useStoreActions();
  return state ? /*#__PURE__*/_jsx(RestfulWrapper, {
    fetch: async () => fetchInquiry({
      data: state.data,
      getUserStatus: userId => api.ofacScreening.getUserStatus(userId),
      getBusinessStatus: businessId => api.ofacScreening.getBusinessStatus(businessId),
      createInquiry: api.ofacScreening.createInquiry
    }),
    renderChild: _ref4 => {
      let {
        data
      } = _ref4;
      return data.inquiry ? /*#__PURE__*/_jsx(OpenPersonaInquiry, _objectSpread({}, data.inquiry)) : /*#__PURE__*/_jsx(RedirectToHome, {
        detailsAdded: true
      });
    },
    renderLoader: renderLoader,
    renderError: renderError
  }) : /*#__PURE__*/_jsx(RedirectToHome, {});
}